import type { Project } from "../../api/types.js";

export const demoAssets = {
  mark: "/assets/truth_logo_mark.png",
  logo: "/assets/truth_logo.png",
  avatar: "/assets/user-avatar.png"
};

export const DEFAULT_SESSION_TITLE = "新的科研会话";

export const starterPrompts = [
  { title: "检索 Agent 仪器自动化论文", tag: "文献检索", prompt: "帮我检索 Agent 在仪器自动化中的最新论文" },
  { title: "设计综述论文大纲", tag: "Academic Research Skills", prompt: "使用 Academic Research Skills，先引导我规划一篇 AI 辅助科研综述的大纲" },
  { title: "整理 AFM 文献池", tag: "资料管理", prompt: "把这批 AFM 文献整理成可引用的文献池" },
  { title: "规划论文工作流", tag: "Academic Research Skills", prompt: "使用 Academic Research Skills，帮我从研究问题到论文成稿设计一个分阶段工作流" }
];

export const recentFiles = [
  { kind: "PDF", title: "微生物 AFM 分段译文", meta: "PDF 双语精读 · 今天 15:42" },
  { kind: "MD", title: "AFM 自动化综述素材", meta: "文稿片段 · 昨天 21:20" },
  { kind: "IMG", title: "iAFM 扫描预览图", meta: "图片 · 6月12日 09:18" }
];

export function projectDisplayName(project: Project) {
  return project.name;
}
